export default __webpack_public_path__ + "static/media/bridged-and-fastened.36c776f5.svg";